import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#333'
      }}>
        <span style={{ color: '#0066cc' }}>ummahSystems.io</span>
        <br />
        under construction
      </div>
    </div>
  );
}

export default App;
